import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const TechnologyPage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const technologies = [
    {
      id: 1,
      title: "量子リザーバコンピューティング",
      description: "業界初の量子リザーバを活用した次世代AI技術",
      details: "従来のAIでは困難だった複雑な時系列予測やパターン認識を、量子効果を利用することで飛躍的に向上させます。",
      applications: ["金融市場予測", "気象予測", "製造業での品質管理"],
      icon: "QUANTUM"
    },
    {
      id: 2,
      title: "深層学習最適化エンジン",
      description: "独自アルゴリズムによる学習効率の最大化",
      details: "企業データに特化した学習アルゴリズムにより、少ないデータでも高精度なモデル構築を実現します。",
      applications: ["顧客行動分析", "需要予測", "リスク評価"],
      icon: "AI"
    },
    {
      id: 3,
      title: "リアルタイム処理基盤",
      description: "大容量データのリアルタイム分析処理",
      details: "クラウドネイティブなアーキテクチャでスケーラブルかつ高速な処理を実現します。",
      applications: ["IoTデータ解析", "ストリーミング処理", "エッジコンピューティング"],
      icon: "REALTIME"
    }
  ];

  const patents = [
    {
      id: 1,
      title: "量子リザーバによる機械学習システム",
      number: "特願2023-123456",
      status: "審査中",
      date: "2023年8月"
    },
    {
      id: 2,
      title: "深層学習における学習効率化手法",
      number: "特許第7234567号",
      status: "登録済み",
      date: "2023年3月"
    },
    {
      id: 3,
      title: "リアルタイムデータ処理最適化システム",
      number: "特願2023-789012",
      status: "出願中",
      date: "2023年11月"
    }
  ];

  return (
    <Layout 
      title="技術力" 
      subtitle="最先端のディープテックで未来を創造"
    >
      {/* 技術タブ */}
      <section style={{ padding: '60px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px', marginBottom: '60px' }}>
                  {[
                    { id: 'overview', title: '技術概要' },
                    { id: 'quantum', title: '量子ML' },
                    { id: 'ai', title: '生成AI' },
                    { id: 'eeg', title: '脳波解析' }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      style={{
                        padding: '12px 24px',
                        borderRadius: '25px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: activeTab === tab.id ? '#3b82f6' : 'transparent',
                        color: activeTab === tab.id ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontSize: '16px'
                      }}
                    >
                      {tab.title}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 技術詳細コンテンツ */}
      <section style={{ padding: '60px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              {activeTab === 'overview' && (
                <div>
                  <h2 style={{ color: '#f1f5f9', marginBottom: '40px', textAlign: 'center' }}>
                    技術スタック概要
                  </h2>
                  <div className="row">
                    {technologies.map((tech) => (
                      <div key={tech.id} className="col-md-4" style={{ marginBottom: '40px' }}>
                        <div className="premium-card" style={{ 
                          padding: '30px', 
                          background: 'rgba(30, 41, 59, 0.8)',
                          border: '1px solid rgba(59, 130, 246, 0.2)',
                          borderRadius: '12px'
                        }}>
                          <div style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center', marginBottom: '20px', color: '#3b82f6' }}>
                            {tech.icon}
                          </div>
                          <h3 style={{ color: '#3b82f6', marginBottom: '15px' }}>{tech.title}</h3>
                          <p style={{ color: '#cbd5e1', marginBottom: '20px' }}>{tech.description}</p>
                          <p style={{ color: '#94a3b8', marginBottom: '20px', fontSize: '14px' }}>
                            {tech.details}
                          </p>
                          <div>
                            <h5 style={{ color: '#f1f5f9', marginBottom: '10px' }}>適用分野：</h5>
                            <ul style={{ color: '#94a3b8', marginLeft: '20px' }}>
                              {tech.applications.map((app, index) => (
                                <li key={index}>• {app}</li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* その他のタブコンテンツ */}
              {activeTab !== 'overview' && (
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>
                    詳細ページは準備中です
                  </h2>
                  <p style={{ color: '#cbd5e1' }}>
                    Coming Soon...
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* 技術仕様書セクション */}
      <section style={{ padding: '100px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title text-center">
                <h2>技術仕様書</h2>
                <p>詳細な技術資料をダウンロードいただけます</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <div className="premium-card" style={{ 
                padding: '40px', 
                textAlign: 'center',
                background: 'rgba(30, 41, 59, 0.8)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                borderRadius: '12px'
              }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '20px', color: '#3b82f6' }}>DOCUMENT</div>
                <h3 style={{ color: '#3b82f6', marginBottom: '20px' }}>技術仕様書 v2.1</h3>
                <p style={{ color: '#cbd5e1', marginBottom: '30px' }}>
                  DeepTeLLの技術アーキテクチャ、API仕様、実装ガイドラインを包含した包括的な技術資料です。
                </p>
                <ul style={{ color: '#94a3b8', textAlign: 'left', marginBottom: '30px' }}>
                  <li>• システムアーキテクチャ詳細</li>
                  <li>• API仕様とインテグレーション</li>
                  <li>• パフォーマンス指標</li>
                  <li>• セキュリティ要件</li>
                  <li>• 導入ガイドライン</li>
                </ul>
                <button 
                  className="btn btn-premium"
                  onClick={() => {
                    // PDF ダウンロード処理
                    const link = document.createElement('a');
                    link.href = '/pdf/technical-specifications.pdf';
                    link.download = 'DeepTeLL_技術仕様書_v2.1.pdf';
                    link.click();
                  }}
                >
                  技術仕様書をダウンロード
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 特許情報セクション */}
      <section style={{ padding: '100px 0', backgroundColor: '#1e293b' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title text-center">
                <h2>特許情報</h2>
                <p>知的財産として保護された技術革新</p>
              </div>
            </div>
          </div>
          <div className="row">
            {patents.map((patent) => (
              <div key={patent.id} className="col-md-4" style={{ marginBottom: '30px' }}>
                <div className="premium-card" style={{ 
                  padding: '25px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    marginBottom: '15px'
                  }}>
                    <span style={{ 
                      background: patent.status === '登録済み' ? '#10b981' : '#f59e0b',
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>
                      {patent.status}
                    </span>
                    <span style={{ color: '#94a3b8', fontSize: '14px' }}>
                      {patent.date}
                    </span>
                  </div>
                  <h4 style={{ color: '#f1f5f9', marginBottom: '10px' }}>
                    {patent.title}
                  </h4>
                  <p style={{ color: '#94a3b8', fontSize: '14px' }}>
                    {patent.number}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA セクション */}
      <section style={{ 
        padding: '80px 0', 
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                技術的なご質問やご相談はお気軽に
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                専門エンジニアがあなたのプロジェクトに最適な技術ソリューションをご提案いたします。
              </p>
              <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                background: 'rgba(255, 255, 255, 0.2)',
                border: '2px solid white',
                color: 'white'
              }}>
                技術相談を申し込む
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default TechnologyPage; 